"use client";
import { Facebook, LinkedIn, WhatsApp } from "@mui/icons-material";
import { useEffect, useState } from "react";
import XIcon from "@mui/icons-material/X";

export const Socials = ({ title }: { title: string }) => {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
    }
  }, []);
  const encodedUrl = encodeURIComponent(currentUrl);
  const encodedTitle = encodeURIComponent(title);

  const shareOptions = [
    {
      name: "facebook",
      icon: <Facebook />,
      link: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      name: "twitter",
      icon: <XIcon />,
      link: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
    },
    {
      name: "whatsapp",
      icon: <WhatsApp />,
      link: `https://wa.me/?text=${encodedTitle} ${encodedUrl}`,
    },
    {
      name: "linkedin",
      icon: <LinkedIn />,
      link: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    },
  ];

  return (
    <>
      {shareOptions.map((platform) => (
        <a
          href={platform.link}
          target="_blank"
          aria-label={`Share on ${platform.name}`}
          key={platform.name}
        >
          {platform.icon}
        </a>
      ))}
    </>
  );
};
